import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useMap } from "react-map-gl";
import { useMapStore } from "../..";

const buildingLayerIds = [
    "building-underground",
    "2d-building",
    "2d-building-outline",
    "3d-building",
    "building-models",
    "building-entrance",
    "building-number-label",
];

function BuildingsBaseMapLayer({ visible }: { visible: boolean }) {
    const map = useMap().current!;
    const { isStyleLoaded } = useMapStore();

    useEffect(() => {
        if (!isStyleLoaded) return;

        const fragments: any[] = (map.getMap() as any).style?.fragments ?? [];
        const visibility = visible ? "visible" : "none";

        for (const { style } of fragments)
            for (const id of buildingLayerIds)
                try { style?.setLayoutProperty(id, "visibility", visibility); } catch { }

        map.triggerRepaint();
    }, [isStyleLoaded, visible]);

    return <></>;
}

export default observer(BuildingsBaseMapLayer);
